import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { CampaignCreateComponent } from './core/components/campaign-create/campaign-create.component';
import { BillingPortalComponent } from './core/components/billing-portal/billing-portal.component';
import { StoreLocationCreateComponent } from './core/components/store-location-create/store-location-create.component';
import { BillingPageComponent } from './presentation/sub-pages/billing-page/billing-page.component';
import { CampaignPageComponent } from './presentation/sub-pages/campaign-page/campaign-page.component';
import { CampaignsPageComponent } from './presentation/sub-pages/campaigns-page/campaigns-page.component';
import { CompanyPageComponent } from './presentation/sub-pages/company-page/company-page.component';
import { StoreLocationDetailPageComponent } from './presentation/sub-pages/store-location-detail-page/store-location-detail-page.component';
import { StoreLocationsPageComponent } from './presentation/sub-pages/store-locations-page/store-locations-page.component';
import { HomeComponent } from './presentation/pages/home/home.component';
import { HowDoesItWorkComponent } from './presentation/pages/how-does-it-work/how-does-it-work.component';
import { PricingComponent } from './presentation/pages/pricing/pricing.component';
import { RegisterComponent } from './presentation/pages/registration/register.component';
import { RegisteredComponent } from './presentation/pages/registered/registered.component';
import { CheckoutSuccessComponent } from './core/components/checkout-success/checkout-success.component';
import { CheckoutFailureComponent } from './core/components/checkout-failure/checkout-failure.component';
import { NavigationComponent } from './core/components/navigation/navigation.component';
import { PromotionsPageComponent } from './presentation/sub-pages/promotions-page/promotions-page.component';
import { PromotionCreateComponent } from './core/components/promotion-create/promotion-create.component';
import { PromotionPageComponent } from './presentation/sub-pages/promotion-page/promotion-page.component';
import { HomeRoutesGuard } from './auth/routerguards/home-routes.guard';
import { GettingStartedComponent } from './presentation/pages/getting-started/getting-started.component';
import { DashboardComponent } from './presentation/pages/dashboard/dashboard.component';
import { OidcCallbackComponent } from './presentation/pages/security/oidc-callback/oidc-callback.component';
import { CheckoutSuccessRoutesGuard } from './auth/routerguards/checkout-success-routes.guard';
import { PricingRoutesGuard } from './auth/routerguards/pricing-routes.guard';
import { AboutComponent } from './presentation/pages/about/about.component';
import { BlogsComponent } from './presentation/pages/blogs/blogs.component';
import { HelpCenterPageComponent } from './presentation/pages/help-center-page/help-center-page.component';
import { FaqComponent } from './presentation/pages/faq/faq.component';
import { CaseStudiesComponent } from './presentation/pages/case-studies/case-studies.component';
import { PrivacyPolicyPageComponent } from './presentation/pages/privacy-policy/privacy-policy-page.component';
import { UserTermsPageComponent } from './presentation/pages/user-terms/user-terms-page.component';
import { ClimatePledgeComponent } from './presentation/pages/climate-pledge/climate-pledge.component';
import { AccountComponent } from './core/components/account/account.component';
import { PartnerTermsPageComponent } from './presentation/pages/partner-terms/partner-terms-page.component';
import { ContactComponent } from './presentation/pages/contact/contact.component';
import { PortalRoutesGuard } from './auth/routerguards/portal-routes.guard';
import { ShoutOutsPageComponent } from './presentation/pages/shout-outs-page/shout-outs-page.component';
import { AccessibilityComponent } from './presentation/pages/accessibility/accessibility.component';
import { HelpCenterComponent } from './core/components/help-center/help-center.component';
import { HelpCenterStoreComponent } from './core/components/help-center-store/help-center-store.component';
import { PlanetBPageComponent } from './presentation/pages/planet-b-page/planet-b-page.component';
import { RegistrationRoutesGuard } from './auth/routerguards/registration-routes.guard';
import { CustomerStoriesComponent } from './presentation/pages/customer-stories/customer-stories.component';
import { CustomerStoryBeesechurgerComponent } from './presentation/sub-pages/customer-story-beesechurgers/customer-story-beesechurgers.component';
import { CustomerStoryVeganDeliCiosoComponent } from './presentation/sub-pages/customer-story-vegan-deli-cioso/customer-story-vegan-deli-cioso.component';
import { CustomerStoryMissNiceBananaComponent } from './presentation/sub-pages/customer-story-miss-nice-banana/customer-story-miss-nice-banana.component';
import { HelpNextStepsComponent } from './presentation/pages/help-next-steps/help-next-steps.component';
import { CustomerStoryVegaLifeComponent } from './presentation/sub-pages/customer-story-vega-life/customer-story-vega-life.component';
import { DataProcessingAgreementPageComponent } from './presentation/pages/data-processing-agreement/data-processing-agreement-page.component';
import { PrivacyPolicy31July2024Component } from './presentation/sub-pages/terms-revisions/privacy-policy-31-july-2024/privacy-policy-31-july-2024.component';
import { UserTerms31July2024Component } from './presentation/sub-pages/terms-revisions/user-terms-31-july-2024/user-terms-31-july-2024.component';
import { PartnerTerms31July2024Component } from './presentation/sub-pages/terms-revisions/partner-terms-31-july-2024/partner-terms-31-july-2024.component';
import { DataProcessingAgreementComponent } from './core/components/data-processing-agreement/data-processing-agreement.component';
import { PartnerTermsComponent } from './core/components/partner-terms/partner-terms.component';
import { PrivacyPolicyComponent } from './core/components/privacy-policy/privacy-policy.component';
import { UserTermsComponent } from './core/components/user-terms/user-terms.component';
import { RedirectAppStoresPageComponent } from './presentation/pages/redirect-app-stores-page/redirect-app-stores-page.component';

const routes: Routes = [
  {
    path: '', component: NavigationComponent, children: [
      // Public 
      { path: 'oidc-callback', component: OidcCallbackComponent },
      { path: 'about', component: AboutComponent },
      { path: 'blogs', component: BlogsComponent },
      { path: 'case-studies', component: CaseStudiesComponent },
      { path: 'help-center', component: HelpCenterPageComponent },
      { path: 'get-the-store-app', component: RedirectAppStoresPageComponent },

      // Terms
      { path: 'privacy-policy', component: PrivacyPolicyPageComponent },
      { path: 'user-terms', component: UserTermsPageComponent },
      { path: 'partner-terms', component: PartnerTermsPageComponent },
      { path: 'data-processing-agreement', component: DataProcessingAgreementPageComponent },

      // Revisions for the terms
      { path: 'privacy-policy-31-july-2024', component: PrivacyPolicy31July2024Component },
      { path: 'user-terms-31-july-2024', component: UserTerms31July2024Component },
      { path: 'partner-terms-31-july-2024', component: PartnerTerms31July2024Component },

      { path: 'contact', component: ContactComponent },
      { path: 'faq', component: FaqComponent },
      { path: 'climate-pledge', component: ClimatePledgeComponent },
      { path: 'shout-outs', component: ShoutOutsPageComponent },
      { path: 'how-it-works', component: HowDoesItWorkComponent },
      { path: 'customer-stories/beesechurgers', component: CustomerStoryBeesechurgerComponent },
      { path: 'customer-stories/vegan-deli-cioso', component: CustomerStoryVeganDeliCiosoComponent },
      { path: 'customer-stories/miss-nice-banana', component: CustomerStoryMissNiceBananaComponent },
      { path: 'customer-stories/vega-life', component: CustomerStoryVegaLifeComponent },
      { path: 'customer-stories', component: CustomerStoriesComponent },
      { path: 'pricing', component: PricingComponent, canActivate: [PricingRoutesGuard] },
      { path: 'register', component: RegisterComponent, canActivate: [RegistrationRoutesGuard] },
      { path: 'registered', component: RegisteredComponent, canActivate: [RegistrationRoutesGuard] },
      { path: 'accessibility', component: AccessibilityComponent },
      { path: 'home', component: HomeComponent, canActivate: [HomeRoutesGuard] },

      // Portal
      { path: 'dashboard', component: DashboardComponent, canActivate: [PortalRoutesGuard] },
      { path: 'getting-started', component: GettingStartedComponent, canActivate: [PortalRoutesGuard] },
      { path: 'checkout-success', component: CheckoutSuccessComponent, canActivate: [CheckoutSuccessRoutesGuard] },
      { path: 'checkout-failure', component: CheckoutFailureComponent, canActivate: [PortalRoutesGuard] },

      { path: 'company', component: CompanyPageComponent, canActivate: [PortalRoutesGuard] },

      { path: 'companies/:companyId/promotions/create', component: PromotionCreateComponent, canActivate: [PortalRoutesGuard] },
      { path: 'companies/:companyId/promotions/:promotionId', component: PromotionPageComponent, canActivate: [PortalRoutesGuard] },

      { path: 'companies/:companyId/stamp-cards/create', component: CampaignCreateComponent, canActivate: [PortalRoutesGuard] },
      { path: 'companies/:companyId/stamp-cards/:campaignId', component: CampaignPageComponent, canActivate: [PortalRoutesGuard] },

      { path: 'store-locations', component: StoreLocationsPageComponent, canActivate: [PortalRoutesGuard] },
      { path: 'companies/:companyId/store-locations/create', component: StoreLocationCreateComponent, canActivate: [PortalRoutesGuard] },
      { path: 'companies/:companyId/store-locations/:storeLocationId', component: StoreLocationDetailPageComponent, canActivate: [PortalRoutesGuard] },

      { path: 'promotions', component: PromotionsPageComponent, canActivate: [PortalRoutesGuard] },
      { path: 'stamp-cards', component: CampaignsPageComponent, canActivate: [PortalRoutesGuard] },
      { path: 'billing', component: BillingPageComponent, canActivate: [PortalRoutesGuard] },
      { path: 'account', component: AccountComponent, canActivate: [PortalRoutesGuard] },
      { path: 'setup-your-store', component: HelpNextStepsComponent, canActivate: [PortalRoutesGuard] },
      { path: 'billing/portal', component: BillingPortalComponent, canActivate: [PortalRoutesGuard] },
      { path: '', redirectTo: "/home", pathMatch: "full" },
    ]
  },

  // Public pages
  { path: 'app/help-center', component: HelpCenterComponent },
  { path: 'app/help-center/store', component: HelpCenterStoreComponent },
  { path: 'app/privacy-policy', component: PrivacyPolicyComponent },
  { path: 'app/user-terms', component: UserTermsComponent },
  { path: 'app/partner-terms', component:PartnerTermsComponent },
  { path: 'app/data-processing-agreement', component: DataProcessingAgreementComponent },

  // Unauthorized pages
  { path: 'forbidden', component: PlanetBPageComponent },
  { path: 'unauthorized', component: PlanetBPageComponent },
  { path: '**', component: PlanetBPageComponent },
];

const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'top',
  onSameUrlNavigation: 'reload'
  // ...any other options you'd like to use
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
